import { useEffect, useState } from 'react';
import { getUser } from '../api';
import { UserData } from '../types';

export function useFetchUser() {
  const [user, setUser] = useState<UserData>();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true)
    getUser()
    .then(({ data }) => {
      setUser(data);
    })
    .catch((err) => {
      console.log(err);
      setError(err);
    })
    .finally(() => setLoading(false))
  }, []);

  return { user, error, loading };
}